import { withCompInfo } from '../../core/withCompInfo'
import { SingleAudioPlayerDefinition, SingleAudioPlayerProps, SingleAudioPlayerCSSVars } from './types'
import { SKIN_HEIGHT_MAP } from './constants'

const staticAudioUrl = 'https://music.wixstatic.com/mp3' // TODO add to topology

export const props = withCompInfo<SingleAudioPlayerProps, SingleAudioPlayerDefinition>(
	['compData', 'compProps'],
	({ compData, compProps }) => {
		const { volume, autoPlay, loop } = compProps
		const { uri, originalFileName, track, artist } = compData
		const playlist = [
			{
				url: `${staticAudioUrl}/${uri}`,
				trackName: track,
				artistName: artist,
			},
		]

		return { volume: volume / 100, autoPlay, loop, originalFileName, playlist }
	}
)

export const css = withCompInfo<SingleAudioPlayerCSSVars, SingleAudioPlayerDefinition>(
	['isMobileView', 'skin'],
	({ isMobileView, skin }) => {
		const view = isMobileView ? 'mobile' : 'desktop'
		return { height: SKIN_HEIGHT_MAP[skin][view] }
	}
)
